import { object, string, addMethod } from "yup";
import {RTMP_URL_REGEX} from "./validateRtmpUrl";
import {LIVESTREAM_TYPE_TIIVII_OTT} from "../common-forms/livestream-form/livestream-form-constants";

addMethod(string, 'validRtmpUrl', errorMessage => {
  return string().test(`is valid rtmp url`, errorMessage, value => {
    return RTMP_URL_REGEX.test(value);
  })
})

export default ({ intl }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });

  return object().shape({
    rtmpUrl: string()
        .when('description', {
          is: LIVESTREAM_TYPE_TIIVII_OTT,
          then: string().nullable(),
          otherwise: string().validRtmpUrl(intl.formatMessage({ id: "event.rtmpurl.novalid" })).required(requiredText),
        }),
    key: string()
        .when('description', {
          is: LIVESTREAM_TYPE_TIIVII_OTT,
          then: string().nullable(),
          otherwise: string().required(requiredText),
        }),
    publishingUrl: string().nullable(),
    description: string().required(requiredText)
  });
};
